export const SET_READY_BUSINESS_TYPE = 'filters/ready_business_types/set_ready_business_type' as const;
